import { authenticatedRequest } from './authApi';
import { REST_API_ORIGIN } from '../platform/endpoints';

const request = (path, options = {}) => authenticatedRequest(`${REST_API_ORIGIN}/api/push${path}`, { ...options, diagSource: 'pushApi' });
export const registerPushDevice = (body) => request('/devices', { method: 'PUT', body });
export const revokePushDevice = (deviceId) => request(`/devices/${encodeURIComponent(deviceId)}`, { method: 'DELETE' });
export const getNotificationPreferences = () => request('/preferences');
export const updateNotificationPreferences = (body) => request('/preferences', { method: 'PATCH', body });
